export const CATALOG_ACTION_TYPE = {
    FETCH_CATALOG_METAS_START: 'FETCH_CATALOG_METAS_START',
    FETCH_CATALOG_METAS_SUCCESS: 'FETCH_CATALOG_METAS_SUCCESS',
    FETCH_CATALOG_METAS_FAILED: 'FETCH_CATALOG_METAS_FAILED',
    FETCH_CATALOGS_AND_RESOURCES_START: 'FETCH_CATFETCH_CATALOGS_AND_RESOURCES_STARTALOG_START',
    FETCH_CATALOGS_AND_RESOURCES_SUCCESS: 'FETCH_CATALOGS_AND_RESOURCES_SUCCESS',
    FETCH_CATALOGS_AND_RESOURCES_FAILED: 'FETCH_CATALOGS_AND_RESOURCES_FAILED',
    FETCH_ADDON_DATA_START: 'FETCH_ADDON_DATA_START',
    FETCH_ADDON_DATA_SUCCESS: 'FETCH_ADDON_DATA_SUCCESS',
    FETCH_ADDON_DATA_FAILED: 'FETCH_ADDON_DATA_FAILED',
    FETCH_TYPE_CATALOGS_START: 'FETCH_TYPE_CATALOGS_START',
    FETCH_TYPE_CATALOGS_SUCCESS: 'FETCH_TYPE_CATALOGS_SUCCESS',
    FETCH_TYPE_CATALOGS_FAILED: 'FETCH_TYPE_CATALOGS_FAILED',
    FETCH_SEARCH_CATALOGS_START: 'FETCH_SEARCH_CATALOGS_START',
    FETCH_SEARCH_CATALOGS_SUCCESS: 'FETCH_SEARCH_CATALOGS_SUCCESS',
    FETCH_SEARCH_CATALOGS_FAILED: 'FETCH_SEARCH_CATALOGS_FAILED',
    FETCH_MOVIE_META_START: 'FETCH_MOVIE_META_START',
    FETCH_MOVIE_META_SUCCESS: 'FETCH_MOVIE_META_SUCCESS',
    FETCH_MOVIE_META_FAILED: 'FETCH_MOVIE_META_FAILED',
    FETCH_MOVIE_STREAM_START: 'FETCH_MOVIE_STREAM_START',
    FETCH_MOVIE_STREAM_SUCCESS: 'FETCH_MOVIE_STREAM_SUCCESS',
    FETCH_MOVIE_STREAM_FAILED: 'FETCH_MOVIE_STREAM_FAILED',
    ADD_ADDON_TO_REDUCER: 'ADD_ADDON_TO_REDUCER',
    REMOVE_ADDON_TO_REDUCER: 'REMOVE_ADDON_TO_REDUCER',
}